import { render } from "./Eduta.vue?vue&type=template&id=2a05db87&scoped=true"
import script from "./Eduta.vue?vue&type=script&lang=js"
export * from "./Eduta.vue?vue&type=script&lang=js"

import "./Eduta.vue?vue&type=style&index=0&id=2a05db87&scoped=true&lang=css"

import exportComponent from "D:\\wwwroot\\douf_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a05db87"]])

export default __exports__